module.exports = __webpack_public_path__ + "media/images/85/sleep_paralysis_night_mare-3536ceec0b372db60be6312cd4d6d2c6.webp";